import type { IComponentFacts, ReportComponentId } from '../../types/report';
import { BurnRunwayChart } from './BurnRunwayChart';
import { CashBridgeChart } from './CashBridgeChart';
import { MarginTrendChart } from './MarginTrendChart';
import { OpexBreakdownChart } from './OpexBreakdownChart';
import { PayrollTrendChart } from './PayrollTrendChart';
import { ProfitTrendChart } from './ProfitTrendChart';
import { RevenueMixChart } from './RevenueMixChart';
import { RevenueTrendChart } from './RevenueTrendChart';

interface IReportChartProps {
  componentId: ReportComponentId;
  facts: IComponentFacts;
}

/** Renders the chart registered for a `*_chart` component id, or nothing for other kinds. */
export const ReportChart = ({ componentId, facts }: IReportChartProps) => {
  switch (componentId) {
    case 'revenue_trend_chart':
      return <RevenueTrendChart facts={facts} />;
    case 'profit_trend_chart':
      return <ProfitTrendChart facts={facts} />;
    case 'revenue_mix_chart':
      return <RevenueMixChart facts={facts} />;
    case 'margin_trend_chart':
      return <MarginTrendChart facts={facts} />;
    case 'opex_breakdown_chart':
      return <OpexBreakdownChart facts={facts} />;
    case 'payroll_trend_chart':
      return <PayrollTrendChart facts={facts} />;
    case 'cash_bridge_chart':
      return <CashBridgeChart facts={facts} />;
    case 'burn_runway_chart':
      return <BurnRunwayChart facts={facts} />;
    default:
      return null;
  }
};
